<template>
	<div :class="{'hashead':!isPC,'hasservice':isKs==1&&rtype==8}" class="recombg">
		<LeaveTel ref="LeaveTel" :isKuaishou="isKs==1&&rtype==8" :estate="[recomItem.subjectAdviserMobile,'','','新盘热推-'+recomItem.hotName,recomItem.projectPkId]" :estateItem="estateItem" :isXprtFlag="isXprtFlag" :isFind="isFind" @setIsFind="getIsFind" @setError="getError" :isCode="showCode" @setIsCode="getIsCode" :selectEstate="selectEstate" :isShowXy="isShowXy" @setIsShowXy="getIsShowXy"></LeaveTel>
		<Header v-if="isPC"></Header>
		<WapHeader v-if="!isPC" :showlogo="true"></WapHeader>
		<div class="banner">
			<div class="imgwrap"><img v-if="recomItem.bannerPath" :src="recomItem.bannerPath"></div>
			<div class="tellinputbox" v-if="!isPC">
				<p class="bttitle" v-if="rtype==1||rtype==3">稀缺好房全城热销</p>
				<p class="bttitle" v-if="rtype==2"></p>
				<div class="bttitle" v-if="rtype==8">
					<p>获取售楼处优惠详情</p>
					<small>(含一房一价表)</small>
					<span>已有<b>{{randomcount}}</b>人领取</span>
				</div>
				<div class="bttitle" v-if="rtype==9"><p>省钱买好房</p></div>
				<div class="inputborder" v-if="selectEstate!='3'">
					<span v-if="rtype==1">楼盘名称<b>*</b>：</span>
					<span v-if="rtype==8">楼盘名</span>
					<el-select v-model="ljdyfydtEstate"  placeholder="请选择楼盘">
						<el-option :key="index" v-for="(item,index) in recomItem.estateList" :label="item.estateName" :value="index"></el-option>
					</el-select>
				</div>
				<div class="inputborder" v-if="rtype==8">
					<span>姓名</span>
					<input type="text" class="input" placeholder="请输入姓名" v-model="ljdyfydtName" >
				</div>
				<div class="inputborder">
					<span v-if="rtype==1">手机号<b>*</b>：</span>
					<span v-if="rtype==8">电话</span>
					<input type="tel" class="input" placeholder="请输入手机号" v-model="ljdyfydtPhone" >
				</div>
				<p class="xy"><span class="checklabel" @click="changeCheck()"><i class="checkbox" :class="isCheck==true?'yes':''"></i>我已阅读</span>
				<a @click="isShowXy=true;" v-if="$store.state.domainIndex==1">《优道用户协议》</a>
				<a @click="isShowXy=true;" v-if="$store.state.domainIndex==2">《溪房用户协议》</a>
				(点击可取消)</p>
				<p class="telbutton" @click="leaveClick()" >{{rtype==8?'立即预约':'立即订阅房源动态'}}</p>
				<p class="tip" v-if="rtype!=8">*订阅后可获得房源详情，优惠降价提前知悉</p>
			</div>
		</div>
		<div class="userwrap" v-if="recomItem&&(recomItem.ucSw==1||recomItem.usSw==1)">
	    <div class="usercount" v-if="recomItem.ucSw==1&&recomItem.userCount!=null"><i class="tzicon"></i><p v-html = recomItem.userCount></p></div>
	    <div class="userbox" :class="{'userboxbar':recomItem.userShowType==2}" v-if="recomItem.usSw==1&&recomItem.userShowPlace==1">
	      <p class="utitle" v-if="recomItem.userShowType==1"><b>最新报名客户</b></p>
	      <i class="m-icon i-huo" v-if="recomItem.userShowType==2"></i>
	      <div class="userlist">
	        <div class="listbox">
	          <div>
	            <li :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li></div>
	          <div>
	            <li v-if="index<5" :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li>
	          </div>
	        </div>
	      </div>
	    </div>
    </div>
		<div class="error" v-show="isError"><span>{{errorMsg}}</span></div>
		<div class="navbox" v-if="!isPC&&isKs!=1">
			<ul>
				<li @click="$router.push({path:'/estate?mtxFisrtLocation='+recomItem.mtxFisrtLocation})"><i class="m-icon mi-qblp"></i>全部楼盘</li>
				<li @click="$router.push({path:'/recommendList'})"><i class="m-icon mi-zslp discount"></i>新盘热推</li>
				<li @click="$router.push({path:'/findHouse?id='+recomItem.projectPkId})"><i class="m-icon mi-bwzf new"></i>帮我找房</li>
				<li @click="$router.push({path:'/calculate'})"><i class="m-icon mi-fdjs"></i>房贷计算</li>
			</ul>
		</div>
		<VideoPlay :videoPath="currVideoPath" @clearPath="currVideoPath=''"></VideoPlay>
		<div class="box">
			<div class="recombox">
				<slot v-if="rtype!=7&&rtype!=8&&rtype!=9">
					<p class="rtitle"><span>{{rtype==3?'—&nbsp;高性价比热销楼盘推荐榜&nbsp;—':'高性价比楼盘热销榜'}}</span></p>
					<div class="tagbox"><span>海量房源</span><span>真实底价</span><span>真实成交价</span></div>
				</slot>
				<div class="yxqtips" v-if="!isPC">页面所展示的价格有效期截止至{{date}}</div>
				<div v-if="recomItem.estateList" class="clearfix">
					<div v-for="(item,index) in recomItem.estateList" :key="index">
						<div class="recomitem" :class="{'ml0':index%3==0}">
							<div class="rttype" v-if="rtype==9"><p>{{item.advantage}}</p></div>
							<div class="imgbox">
								<i v-if="showTv==1&&item.tvUrl&&item.tvUrl!=''" class="i-video" @click="currVideoPath=item.tvUrl"></i>
								<img v-if="isKs==1" v-lazy="item.path+'&type=1&size=600x300'" />
								<img v-else v-lazy="item.path+'&type=1&size=600x300'" @click="$router.push({path:'/estateDetail?estateId='+item.estateId})" />
								<slot v-if="rtype==1||rtype==3||rtype==4||rtype==6||rtype==7"><span class="gzhu" v-if="item.randomNumber > 0">已有<em>{{item.randomNumber}}</em>人关注</span></slot>
								<slot v-if="rtype==1||rtype==7||rtype==9">
									<span @click="$refs.LeaveTel.leaveCallClick(item.phone,item.estateId,item.estateName,recomItem.hotName,recomItem.projectPkId)"><a class="b-tell" href="javascript:void(0);"><i class="m-icon i-tell"></i>咨询热线</a></span>
									<p class="salepoint" v-if="item.sellingPoint1 != null && item.sellingPoint1!=''&&rtype==1"><span>{{item.sellingPoint1}}</span><span>{{item.sellingPoint2}}</span></p>
								</slot>
								<span v-if="rtype==9" class="b-status" :class="{'sm':item.estateStatus.length>2}"><b>{{item.estateStatus}}</b></span>
							</div>
							<div class="infobox">
								<p class="b-title"><b>{{item.estateName}}</b><slot v-if="rtype==1||rtype==3||rtype==4||rtype==7||rtype==8||rtype==9"><span v-if="item.price!=null&&item.price!=0">{{rtype==8?'楼盘单价:':'均价'}}{{item.price}}{{item.priceUnit}}</span><span v-else>售价待定</span></slot></p>
								<slot v-if="rtype!=3&&rtype!=8&&rtype!=9">
									<p :class="{'long':rtype==2}">地址： [{{item.locationSt}}-{{item.locationSC}}] {{item.positionDetail}}</p>
									<p v-if="rtype!=5&&rtype!=6">优势： {{item.advantage}}</p>
									<p>户型： {{item.mTouseholdType}}</p>
									<p>建面： {{item.acreage}}</p>
									<p v-if="rtype==5||rtype==6" class="b-price"><span v-if="item.price!=null&&item.price!=0">均价{{item.price}}{{item.priceUnit}}</span><span v-else>售价待定</span></p>
								</slot>
								<slot v-else-if="rtype==8">
									<p><span>建面户型：</span>{{item.acreage}}|{{item.mTouseholdType}}</p>
									<p><span>楼盘优势：</span>{{item.advantage}}</p>
									<p><span>楼盘地址：</span>[{{item.locationSt}}-{{item.locationSC}}] {{item.positionDetail}}</p>
								</slot>
								<slot v-else-if="rtype==9">
									<p class="ystag" v-if="item.estateTagList&&item.estateTagList.length>0"><span :key="index1" v-for="(item1,index1) in item.estateTagList">{{item1.name}}</span></p>
									<p><span>建面面积：</span>{{item.acreage}} <span>主力户型：</span>{{item.mTouseholdType}}</p>
									<p><span>地址：</span>[{{item.locationSt}}-{{item.locationSC}}] {{item.positionDetail}}</p>
								</slot>
								<slot v-else>
									<p><i class="m-icon mi-hx"></i><b>主力户型：</b>{{item.mTouseholdType}}</p>
									<p><i class="m-icon mi-mj"></i><b>建筑面积：</b>{{item.acreage}}</p>
									<p><i class="m-icon mi-dz"></i><b>地址：</b>[{{item.locationSt}}-{{item.locationSC}}] {{item.positionDetail}}</p>
									<p><i class="m-icon mi-ys"></i><b>优势：</b>{{item.advantage}}</p>
								</slot>
							</div>
							<div class="tellinputbox" v-if="rtype==1||rtype==9">
								<div class="inputborder" v-if="selectEstate=='2'">
									<span>楼盘名称<b>*</b>：</span>
									<el-select v-model="lpidvalue[index]"  placeholder="请选择楼盘">
										<el-option v-for="(eitem,eindex) in recomItem.estateList" :key="eindex" :label="eitem.estateName" :value="eitem.estateId"></el-option>
									</el-select>
								</div>
								<div class="inputborder">
									<span>手机号<b>*</b>：</span>
									<input type="tel" placeholder="请输入手机号" class="input" v-model="telvalue[index]">
								</div>
								<!-- <div class="code" v-show="codeInputShow==1">
									<div class="inputborder">
										<input type="text" placeholder="请输入验证码" class="input" v-model="codevalue[index]">
									</div>
									<button class="codebutton" v-show="codeShows[index]" @click="getCode(telvalue[index],index)" >获取验证码</button>
									<button class="codebutton" v-show="!codeShows[index]">重新获取{{counts[index]}}s</button>
								</div> -->
								<p class="xy"><span class="checklabel" @click="changeCheck()"><i class="checkbox" :class="isCheck==true?'yes':''"></i>我已阅读</span>
								<a @click="isShowXy=true;" v-if="$store.state.domainIndex==1">《优道用户协议》</a>
								<a @click="isShowXy=true;" v-if="$store.state.domainIndex==2">《溪房用户协议》</a>(点击可取消)</p>
								<button class="telbutton" @click="okClick(index)">获取最新报价</button>
							</div>
							<div v-else-if="rtype==7" class="tellinputbox">
								<div class="inputborder">
									<input type="tel" placeholder="请输入手机号" class="input" v-model="telvalue[index]">
								</div>
								<!-- <div class="code" v-show="codeInputShow==1">
									<div class="inputborder">
										<input type="text" placeholder="请输入验证码" class="input" v-model="codevalue[index]">
									</div>
									<span class="codebutton" v-show="codeShows[index]" @click="getCode(telvalue[index],index)" >验证码</span>
									<span class="codebutton" v-show="!codeShows[index]">{{counts[index]}}s</span>
								</div> -->
								<p class="xy"><span class="checklabel" @click="changeCheck()"><i class="checkbox" :class="isCheck==true?'yes':''"></i>我已阅读</span>
								<a @click="isShowXy=true;" v-if="$store.state.domainIndex==1">《优道用户协议》</a>
								<a @click="isShowXy=true;" v-if="$store.state.domainIndex==2">《溪房用户协议》</a>
								(点击可取消)</p>
								<span class="telbutton" @click="okClick(index)">获取最新报价</span>
							</div>
							<div v-else-if="rtype==8" class="tellinputbox">
								<p class="bttitle">获取更多项目信息及优惠</p>
								<div class="inputborder">
									<input type="text" placeholder="请输入姓名" class="input" v-model="namevalue[index]">
								</div>
								<div class="inputborder">
									<input type="tel" placeholder="请输入手机号(必填)" class="input" v-model="telvalue[index]">
								</div>
								<!-- <div class="code" v-show="codeInputShow==1">
									<div class="inputborder">
										<input type="text" placeholder="请输入验证码" class="input" v-model="codevalue[index]">
									</div>
									<span class="codebutton" v-show="codeShows[index]" @click="getCode(telvalue[index],index)" >验证码</span>
									<span class="codebutton" v-show="!codeShows[index]">{{counts[index]}}s</span>
								</div> -->
								<p class="xy"><span class="checklabel" @click="changeCheck()"><i class="checkbox" :class="isCheck==true?'yes':''"></i>我已阅读</span>
								<a @click="isShowXy=true;" v-if="$store.state.domainIndex==1">《优道用户协议》</a>
								<a @click="isShowXy=true;" v-if="$store.state.domainIndex==2">《溪房用户协议》</a>
								(点击可取消)</p>
								<span class="telbutton" @click="okClick(index)">立即预约</span>
							</div>
							<div class="btnbox clearfix" v-else>
								<span class="dh" @click="$refs.LeaveTel.leaveCallClick(item.phone,item.estateId,item.estateName,recomItem.hotName,recomItem.projectPkId)"><a href="javascript:void(0);" class="mltell">{{rtype==6?'':'电话咨询'}}</a></span>
								<span class="bj" @click="$refs.LeaveTel.leaveClick(24,item.estateId,item.estateName,recomItem.hotName,recomItem.projectPkId,true,codeInputShow)">{{rtype==1||rtype==3?'获取最新报价和优惠':''}}{{rtype==2||rtype==4?'获取最新报价':''}}{{rtype==5?'最新报价':''}}</span>
							</div>
              <div class="kfsbox">
                <p v-if="item.developerName&&item.developerName!=''&&(showPermitFlag||showDev==1)">{{rtype==8?'':'开发商：'}}{{item.developerName}}</p>
                <p v-if="item.permit&&item.permit!=''&&(showPermitFlag||showPermit==1)">{{rtype==8?'':'预售证号：'}}{{item.permit}}</p>
              </div>
						</div>
						<div class="userwrap" v-if="recomItem.usSw==1&&(index==parseInt(recomItem.estateList.length/2)-1)&&recomItem.userShowPlace==2">
					    <div class="userbox" :class="{'userboxbar':recomItem.userShowType==2}" v-if="recomItem.usSw==1">
					      <p class="utitle" v-if="recomItem.userShowType==1"><b>最新报名客户</b></p>
					      <i class="m-icon i-huo" v-if="recomItem.userShowType==2"></i>
					      <div class="userlist">
					        <div class="listbox">
					          <div>
					            <li :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li></div>
					          <div>
					            <li v-if="index<5" :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li>
					          </div>
					        </div>
					      </div>
					    </div>
				    </div>
			   	</div>
				</div>
				<div class="userwrap" v-if="recomItem&&recomItem.usSw==1&&recomItem.userShowPlace==3">
			    <div class="userbox" :class="{'userboxbar':recomItem.userShowType==2}" v-if="recomItem.usSw==1">
			      <p class="utitle" v-if="recomItem.userShowType==1"><b>最新报名客户</b></p>
			      <i class="m-icon i-huo" v-if="recomItem.userShowType==2"></i>
			      <div class="userlist">
			        <div class="listbox">
			          <div>
			            <li :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li></div>
			          <div>
			            <li v-if="index<5" :key="index" v-for="(item,index) in userItem"><span>{{item.name}}</span><span>{{item.phone}}</span><span>{{item.time}}</span></li>
			          </div>
			        </div>
			      </div>
			    </div>
		    </div>
				<span class="showForm" @click="hideForm=false"></span>
				<div class="tellinputbox bottom" :class="{'hide':hideForm&&isPC}">
					<span class="colse" @click="hideForm=true" v-if="isPC">关闭</span>
					<p class="rtitle" v-if="rtype!=8"><span>{{rtype==3?'—&nbsp;&nbsp;还没找到满意的楼盘？&nbsp;—':'找不到满意的楼盘？'}}</span></p>
					<p class="rtitle" v-else>更多优质楼盘信息获取</p>
					<p class="rtitle-s" v-if="rtype!=8">填写信息，为您精确匹配房源</p>
					<div class="inputborder" v-if="selectEstate!='3'">
						<span v-if="rtype!=8">楼盘名称<b v-if="rtype==1">*</b>：</span>
						<el-select v-model="yxlpvalue"  placeholder="请选择楼盘">
							<el-option :key="index" v-for="(item,index) in recomItem.estateList" :label="item.estateName" :value="index"></el-option>
						</el-select>
					</div>
					<!-- <div class="inputborder" v-if="rtype!=8">
						<span>意向楼盘<b v-if="rtype==1">*</b>：</span>
						<input type="text" placeholder="请输入楼盘名" class="input" v-model="yxlpvalue">
					</div> -->
					<div class="inputborder">
						<span v-if="rtype!=8">姓名<b v-if="rtype==1">*</b>：</span>
						<input type="text" placeholder="请输入姓名" class="input" v-model="xmvalue">
					</div>
					<div class="inputborder" v-if="rtype!=8">
						<span>手机号<b v-if="rtype==1">*</b>：</span>
						<input type="tel" placeholder="请输入手机号" class="input" v-model="sjhvalue">
					</div>
					<div class="inputborder" v-else>
						<input type="tel" placeholder="请输入手机号(必填)" class="input" v-model="sjhvalue">
					</div>
					<!-- <div class="code" v-show="codeInputShow!=2">
						<div class="inputborder">
							<span v-if="rtype!=1&&rtype!=8">验证码：</span>
							<input type="text" placeholder="请输入验证码" class="input" v-model="yzmvalue">
						</div>
						<span class="codebutton wait" v-show="!codeShow">{{count}}s</span>
						<span class="codebutton" v-show="codeShow" @click="getCode(sjhvalue,'codeShow','count','timer')">验证码</span>
					</div> -->
					<p class="xy"><span class="checklabel" @click="changeCheck()"><i class="checkbox" :class="isCheck==true?'yes':''"></i>我已阅读</span>
					<a @click="isShowXy=true;" v-if="$store.state.domainIndex==1">《优道用户协议》</a>
					<a @click="isShowXy=true;" v-if="$store.state.domainIndex==2">《溪房用户协议》</a>
					(点击可取消)</p>
					<p class="telbutton" @click="leaveSpfyClick">{{rtype==8?'立即预约':'立即匹配房源'}}</p>
				</div>
			</div>
		</div>
		<Footer :isKuaishou="isKs" :showTech="showTech"></Footer>
	</div>
</template>

<script>
import Header from '@/components/public/Header'
import WapHeader from '@/components/public/WapHeader'
import LeaveTel from '@/components/public/LeaveTel'
import Footer from '@/components/public/Footer'
import VideoPlay from '@/components/public/VideoPlay'
export default {
	name: 'Recommend',
	components:{
		'Header':Header,
		'WapHeader':WapHeader,
		'LeaveTel':LeaveTel,
		'Footer':Footer,
		'VideoPlay':VideoPlay,
	},
	data () {
		return {
			rtype:this.$route.query.t?this.$route.query.t:1,
			isPC:this.$store.state.isPC,
			recomItem:[],
			userItem:[],
			lpvalue:[],
			lpidvalue:[],
			namevalue:[],
			telvalue:[],
			// codevalue:[],
			// codeShow_t:true,
			// count_t: '',
			// codeShows:[],
			// counts:[],
			// codeShow:true,
			// count: '',
			// timer_t: null,
			// timers: [],
			// timer: null,
			isFind:false,
			isXprtFlag:true,
			estateItem:[],
			hideForm:true,
			ljdyfydtEstate:null,
			ljdyfydtName:null,
			ljdyfydtPhone:null,
			// ljdyfydtCode:null,
			errorMsg:'请输入验证码',
			codeInputShow: 2,
			selectEstate: -1,
			currVideoPath:'',
			isError:false,
			yxlpvalue:null,
			xmvalue:'',
			sjhvalue:'',
			yzmvalue:'',
			showPermitFlag:false,
			randomcount:parseInt(Math.random()*(1200-1100)+1100),
			showTech:0,
			showDev:0,
			showTv:2,
			showPermit:0,
			isKs:1,
			showCode:false,
			isCheck:false,
			isShowXy:false,
			date:''
		}
	},
	computed:{
		listenIsPC(){
			return this.$store.state.isPC;
		},
		listenIsError(){
			return this.isError
		}
	},
	watch:{
		listenIsPC:function(boo){
			this.isPC = this.$store.state.isPC;
		},
		listenIsError(boo){
			if(this.isError){
				setTimeout(() => {
					this.isError=false;
					this.errorMsg='';
				}, 2000);
			}
		}
	},
	mounted(){
		var _this = this;
		_this.getRecom();
	 //判断是否是baidu渠道进来的,显示开发商和预售许可
	 var channel = _this.$route.query.channel;
		if(sessionStorage.getItem('channel')!=null){
			channel  = sessionStorage.getItem('channel');
		}
		if(channel && channel.indexOf('baidu')!=-1){
			_this.showPermitFlag = true;
		}
		_this.setStyle();
		_this.setDate();
	},
	methods:{
		setDate(){
			var _date = new Date().getTime()+1000*60*60*24*3;
			var date = new Date(_date);
			var year = date.getFullYear(), month = date.getMonth()+1, day = date.getDate();
			this.date = year+'年'+month+'月'+day+'日'
		},
		changeCheck(){
	      this.isCheck=!this.isCheck;
	    },
		setStyle(){
		 document.querySelector('link[name="recom"]').setAttribute('href', '/static/recommend/recommend'+this.rtype+'.css');
		},
		getRecom:function(){
			this.$http.get('/api/baidu/getHotThemeEstateList?id='+this.$route.query.id).then((response)=>{
				this.recomItem = response.data.result
				this.estateItem = response.data.result.estateList
				this.userItem = response.data.result.usList
				this.showTech = response.data.result.showTech
				this.showDev = response.data.result.showDev
				this.showTv = response.data.result.showTv
				this.showPermit = response.data.result.showPermit
        		this.isKs = response.data.result.isKs
				this.codeInputShow = response.data.result.codeInputShow
				this.selectEstate = response.data.result.selectEstate
				this.estateItem.forEach(item=>{
					this.lpvalue.push(item.estateName)
					this.lpidvalue.push(item.estateId)
					// this.codeShows.push(true)
					// this.counts.push('')
					// this.timers.push(null)
				})
			}).catch((response)=>{
				console.log(response)
			})
			this.$http.get('/api/estateSearch/getLocationParams?locationId='+this.storage.get('city').citySite).then((response)=>{
				this.dqoptions = response.data.result.locationList
			}).catch((response)=>{
				console.log(response)
			})
			this.$http.get('/api/estateSearch/getPurchaseParams').then((response)=>{
				this.ysoptions = response.data.result.budgetList
			}).catch((response)=>{
				console.log(response)
			})
		},
		getIsShowXy(data){
			this.isShowXy = data;
		},
		getIsFind:function(data){
			this.isFind = data;
			this.showCode=false;
		},
		getIsCode(data){
			this.showCode=data;
		},
		getError(data){
			this.showError(data);
		},
		showError(text){
			this.isError =true;
			this.errorMsg = text;
		},
		checkPhone(mobile){
			if(!this.$refs.LeaveTel.checkPhone(mobile)){
				this.showError('请输入正确的手机号码');
				return false;
			}else{
				return true;
			}
		},
		leaveClick:function(){
			if(this.selectEstate!='3'&&this.ljdyfydtEstate==null){
				this.showError('请选择楼盘');
				return false;
			}
			// console.log(this.checkPhone(this.ljdyfydtPhone))
			if(this.checkPhone(this.ljdyfydtPhone)){
				// console.log(this.ljdyfydtPhone)
				if(this.isCheck!=true){
					this.showError('请阅读并勾选用户协议');
					return false;
				}
				if(this.selectEstate!='3'){
					var item=this.recomItem.estateList[this.ljdyfydtEstate];
					if(this.codeInputShow!=2){
						this.$refs.LeaveTel.getCode(this.ljdyfydtPhone);
						this.$refs.LeaveTel.setParams(23,item.estateId,item.estateName,this.recomItem.hotName,this.recomItem.projectPkId,null,this.ljdyfydtPhone,this.ljdyfydtName);
						// if(this.ljdyfydtCode==null || this.ljdyfydtCode==''){
						// 	this.showError('请输入验证码');
						// }else{
						// 	this.checkCode(this.ljdyfydtPhone,this.ljdyfydtCode,23,null,null,this.recomItem.hotName,this.recomItem.projectPkId,null,this.ljdyfydtPhone,this.ljdyfydtName)
						// }
					}else{
						this.$refs.LeaveTel.setParams(23,item.estateId,item.estateName,this.recomItem.hotName,this.recomItem.projectPkId,null,this.ljdyfydtPhone,this.ljdyfydtName);
						this.$refs.LeaveTel.sendFromInLine();
						this.isFind =true;
					}
				}else{
					if(this.codeInputShow!=2){
						this.$refs.LeaveTel.getCode(this.ljdyfydtPhone);
						this.$refs.LeaveTel.setParams(23,null,null,this.recomItem.hotName,this.recomItem.projectPkId,null,this.ljdyfydtPhone,this.ljdyfydtName);
					}else{
						this.$refs.LeaveTel.setParams(23,null,null,this.recomItem.hotName,this.recomItem.projectPkId,null,this.ljdyfydtPhone,this.ljdyfydtName);
						this.$refs.LeaveTel.sendFromInLine();
						this.isFind =true;
					}
				}
				this.ljdyfydtPhone='';
				this.ljdyfydtName='';
			}
		},
		okClick:function(index){
			if(this.checkPhone(this.telvalue[index])){
				if(this.isCheck!=true){
					this.showError('请阅读并勾选用户协议');
					return false;
				}
				if(this.codeInputShow==1){
					this.$refs.LeaveTel.getCode(this.telvalue[index]);
					this.$refs.LeaveTel.setParams(24,this.lpidvalue[index],this.lpvalue[index],this.recomItem.hotName,this.recomItem.projectPkId,null,this.telvalue[index],this.namevalue[index]);
					// if(this.codevalue[index]==null || this.codevalue[index]==''){
					// 	this.showError('请输入验证码');
					// }else{
					// 	this.checkCode(this.telvalue[index],this.codevalue[index],24,this.lpidvalue[index],this.lpvalue[index],this.recomItem.hotName,this.recomItem.projectPkId,null,this.telvalue[index],this.namevalue[index]);
					// }
				}else{
					this.$refs.LeaveTel.setParams(24,this.lpidvalue[index],this.lpvalue[index],this.recomItem.hotName,this.recomItem.projectPkId,null,this.telvalue[index],this.namevalue[index]);
					this.$refs.LeaveTel.sendFromInLine();
					this.isFind = true;
				}
				this.telvalue[index]='';
				this.namevalue[index]='';
			}
		},
		leaveSpfyClick:function(){
			if(this.selectEstate!='3'&&this.rtype!=8&&this.yxlpvalue==null){
				this.showError('请选择楼盘');
			}else{
				if(this.xmvalue==null || this.xmvalue==''){
					this.showError('请输入姓名');
				}else{
					if(this.checkPhone(this.sjhvalue)){
						if(this.isCheck!=true){
							this.showError('请阅读并勾选用户协议');
							return false;
						}
						if(this.selectEstate!='3'){
							var item=this.recomItem.estateList[this.yxlpvalue];
							if(this.codeInputShow!=2){
								this.$refs.LeaveTel.getCode(this.sjhvalue);
								this.$refs.LeaveTel.setParams(25,item.estateId,item.estateName,this.recomItem.hotName,this.recomItem.projectPkId,null,this.sjhvalue,this.xmvalue);
								// if(this.yzmvalue==null || this.yzmvalue==''){
								// 	this.showError('请输入验证码');
								// }else{
								// 	this.checkCode(this.sjhvalue,this.yzmvalue,25,null,this.yxlpvalue,this.recomItem.hotName,this.recomItem.projectPkId,null,this.sjhvalue,this.xmvalue);
								// }
							}else{
								this.$refs.LeaveTel.setParams(25,item.estateId,item.estateName,this.recomItem.hotName,this.recomItem.projectPkId,null,this.sjhvalue,this.xmvalue);
								this.$refs.LeaveTel.sendFromInLine();
								this.isFind = true;
							}
						}else{
							if(this.codeInputShow!=2){
								this.$refs.LeaveTel.getCode(this.sjhvalue);
								this.$refs.LeaveTel.setParams(25,null,null,this.recomItem.hotName,this.recomItem.projectPkId,null,this.sjhvalue,this.xmvalue);
							}else{
								this.$refs.LeaveTel.setParams(25,null,null,this.recomItem.hotName,this.recomItem.projectPkId,null,this.sjhvalue,this.xmvalue);
								this.$refs.LeaveTel.sendFromInLine();
								this.isFind = true;
							}
						}
						this.sjhvalue='';
						this.xmvalue='';
					}
				}
			}
		},
	}
}
</script>

<style scoped>
	/*@import '../../static/recommend/recommend9.css';*/
	.navbox{background:#fff;padding:15px 10px 10px;margin-bottom:15px;}
	.navbox ul{display:table;width:100%;text-align:center;}
	.navbox li{display:table-cell;line-height:24px;}
	.navbox li .m-icon{display:block;margin:0 auto;width:44px;height:44px;}
	.m-icon.new,.m-icon.discount{position:relative;}
	.m-icon.new:before,.m-icon.discount:before{content:'';position:absolute;top:-5px;left:28px;height:14px;background:url(../assets/images/icons.png) no-repeat;background-size:225px;}
	.m-icon.new:before{width:14px;background-position:-155px 0;}
	.m-icon.discount:before{width:26px;background-position:-170px 0;}
	.mi-qblp{background-position:0 -34px;}
	.mi-zslp{background-position:-90px -34px;}
	.mi-bwzf{background-position:-45px -34px;}
	.mi-fdjs{background-position:-135px -34px;}
	.banner{position:relative;min-height:360px;}
	.el-select{display:block;}
	.el-select /deep/ .el-input__inner{border:0;line-height:38px;height:38px;padding-left:0;padding-right:0;background:transparent;}
	/*.el-select /deep/ .el-input{padding-right:20px;box-sizing:border-box;}*/
	.banner /deep/ .el-input__suffix,.bottom /deep/ .el-input__suffix{right:-5px;width:25px;position:absolute;}
	.banner img{width:100%;height:100%;object-fit:cover;display:block;}
	.error{position:fixed;left:0;right:0;bottom:80px;z-index:99;text-align:center;}
	.error span{background:rgba(0,0,0,0.8);color:#fff;display:inline-block;padding:10px 15px;border-radius:3px;line-height:20px;}
	.imgbox img{display:block;width:100%;height:100%}
	.imgbox .i-video{position:absolute;left:50%;top:50%;margin-left:-28px;margin-top:-28px;width:56px;height:56px;border-radius:50%;background:#fff url(../assets/images/i-video.png) 21px center no-repeat;background-size:19px;box-shadow:2px 2px 20px rgba(0,0,0,.5);z-index:1;}
	.kfsbox{text-align:center;font-size:12px;line-height:20px;margin-top:-8px;color:#555;padding:0 10px 15px;}
	.gzhu em{font-style:normal;}
	.yxqtips{font-size:13px;text-align:center;background:#fff;line-height:25px;box-shadow:0 1px 5px rgba(0,0,0,0.2);border-radius:3px;color:#666;}
@media (min-width:769px){
	.banner{padding-bottom:0;margin-bottom:30px;}
	.banner img{height:500px}
	.recombox .clearfix{column-count:3;column-gap:40px;padding-top:10px;}
	.recomitem{break-inside:avoid;margin-top:0;margin-bottom:30px;box-shadow:none;border:1px solid #eee;}
	.tellinputbox.bottom{position:fixed;right:10px;bottom:50px;padding:30px;width:320px;z-index:1;}
	.showForm{background:url(../assets/images/wnyx.png);width:100px;height:107px;position:fixed;right:0;bottom:100px;}
	.hide{display:none;}
	.colse{position:absolute;right:15px;top:12px;color:#999;font-size:12px;display:inline;cursor:pointer;}
	.telbutton,.okbtn,.codebutton,.i-video,.imgbox img{cursor:pointer;}
	.recomitem >>> .el-input__suffix-inner{left:180px;}
}
</style>



// WEBPACK FOOTER //
// src/components/Recommend.vue